import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { RecoilRoot } from 'recoil'; // Importez RecoilRoot
import { ChainlitAPI, ChainlitContext } from "@chainlit/react-client";

import '@fontsource/inter/300.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/700.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

// const CHAINLIT_SERVER = "http://localhost:80/chainlit";
//const CHAINLIT_SERVER = "https://conversequery-backend-376389693617.europe-west1.run.app/chainlit"
const CHAINLIT_SERVER = "https://conversequery-backend.intelcia.com/chainlit"

const apiClient = new ChainlitAPI(CHAINLIT_SERVER, "webapp");



const theme = createTheme({
  typography: {
    fontFamily: '"Inter", Roboto', // Définir Inter comme police par défaut
  },

});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <ChainlitContext.Provider value={apiClient}>
        <RecoilRoot>
          <App />
        </RecoilRoot>
      </ChainlitContext.Provider>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
